import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DxFormComponent } from 'devextreme-angular/ui/form';
import { RouteKeys } from 'src/app/share/helper/route-keys.helper';
import { ApiService } from 'src/app/share/services/api.service';
import { ConfigService } from 'src/app/share/services/config.service';
import notify from 'devextreme/ui/notify';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  standalone: false,
})
export class ResetPasswordComponent {
  @ViewChild('resetForm', { static: false }) resetForm: DxFormComponent;

  isSending: boolean = false;

  formData: any = {
    token: '',
    password: '',
    passwordConfirm: '',
  };

  constructor(private route: ActivatedRoute, private apiService: ApiService, private router: Router, public configService: ConfigService) {
    this.route.queryParamMap.subscribe({
      next: (paras) => {
        const token = paras.get('token') || '';
        if (token !== undefined && token !== null && token.length > 0) {
          this.formData.token = token;
        }
      },
    });
  }

  passwordComparison() {
    return this.formData.password;
  }
  onClickCancel(e): void {
    this.router.navigate(['extern/start']);
  }

  onClickSave(e): void {
    var validationResult = this.resetForm.instance.validate();
    if (validationResult.isValid) {
      this.isSending = true;
      this.apiService.post<any>(RouteKeys.Extern.Register.reset_password, this.formData).subscribe({
        next: (response) => {
          if (response !== undefined && response !== null) {
            if (response.ok === true) {
              notify(
                {
                  message: 'Ihr Passwort wurde erfolgreich zurückgesetzt.',
                  width: 'auto',
                },
                'success',
                4000
              );
              setTimeout(() => {
                this.router.navigate(['extern/start']);
              }, 3000);
            } else {
              this.isSending = false;
              notify({ message: response.message || 'Es ist ein Problem aufgetreten.', width: 'auto' }, 'error', 4000);
            }
          } else {
            this.isSending = false;
            notify({ message: response.message, width: 'auto' }, 'error', 4000);
            throw new Error('Fehler! Keine Response!');
          }
        },
        error: (err) => {
          this.isSending = false;
          notify({ message: 'Server Fehler!', width: 'auto' }, 'error', 4000);
          throw err;
        },
      });
    }
  }
}
